import api from "./api";

export interface AuditItem {
  id: string;
  autorId: string | null;
  autorNome: string | null;
  autorPerfil: string | null;
  entidade: string;
  entidadeId: string | null;
  entidadeLabel: string | null;
  acao: string;
  detalhes: any;
  criadoEm: string;
}

export async function listarAuditoria(filtros?: { entidade?: string; acao?: string; autorId?: string; q?: string; limit?: number }) {
  const params = new URLSearchParams();
  if (filtros?.entidade) params.append("entidade", filtros.entidade);
  if (filtros?.acao) params.append("acao", filtros.acao);
  if (filtros?.autorId) params.append("autorId", filtros.autorId);
  if (filtros?.q) params.append("q", filtros.q);
  if (filtros?.limit) params.append("limit", String(filtros.limit));
  const r = await api.get(`/auditoria?${params.toString()}`);
  return r.data.data as AuditItem[];
}
